import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useSEO } from '@/hooks/useSEO';

const NotFound = () => {
  const location = useLocation();

  // SEO Configuration
  useSEO({
    title: "Page Not Found - ChessHatch",
    description: "The page you're looking for doesn't exist. Return to ChessHatch to continue your chess journey with tutorials, puzzles, and games.",
    keywords: "404 error, page not found, chesshatch"
  });

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-900 via-purple-950/95 to-slate-950">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4 text-white">404</h1>
        <p className="text-xl text-slate-300 mb-4">Oops! Page not found</p>
        <a href="/" className="text-primary hover:text-primary/80 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
